<app-questionnaire
  [questions]="questions$ | async"
  [pageNo]="pageNo$ | async"
  [pageSummary]="pageSummary$ | async"
  [baseRoute]="routerLink"
  (questionRatingChange)="onChange($event)"
  (submitAnswers)="sendAnswers()"></app-questionnaire>
